import httpClient from "../http/http-client";
import { IMeasurementUnit } from '../transaction/transaction.model';
import { IPostMeasurementUnit } from './measurement-unit-model';

export default class MeasurementUnitService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(): Promise<IMeasurementUnit[]> {
    return this.http.get(`measurement-unit`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllWithPagination(searchQuery: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IMeasurementUnit[] }> {
    return this.http.get(`measurement-unit?page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}${searchQuery ? `&nameIncludes=${searchQuery}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getOne(measurementUnitId: string): Promise<IMeasurementUnit> {
    return this.http.get(`measurement-unit/${measurementUnitId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async create(measurementUnit: IPostMeasurementUnit): Promise<IMeasurementUnit> {
    return this.http.post(`measurement-unit`, measurementUnit)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async edit(measurementUnitId: string, measurementUnit: IPostMeasurementUnit): Promise<IMeasurementUnit> {
    return this.http.patch(`measurement-unit/${measurementUnitId}`, measurementUnit)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}